import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { actions } from "../../actions/actionsWrapper";
import { IAppYeuCauHoTroLoadDetailStart, IAppYeuCauHoTroLoadSelectStart, IAppYeuCauHoTroUpdatePhanHoiStart, eAppYeuCauHoTroActionTypeIds } from "../../action-types/app-phuhuynh/IAppYeuCauHoTroActionTypes";

const appYeuCauHoTroApi = apiWrapper.appYeuCauHoTro;
function* loadSelectWorker(action: IAppYeuCauHoTroLoadSelectStart): any {

    const res: IBaseResponeModel = yield call([appYeuCauHoTroApi, appYeuCauHoTroApi.selectAsync], action.payload)
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.loadSelectSuccess(res.data))
    } else {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.loadSelectError(res.message || "Không tải được yêu cầu hỗ trợ"))
    }
}

function* loadDetailWorker(action: IAppYeuCauHoTroLoadDetailStart): any {

    const res: IBaseResponeModel = yield call([appYeuCauHoTroApi, appYeuCauHoTroApi.selectDetailAsync], action.payload)
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.loadDetailSuccess(res.data))
    } else {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.loadDetailError(res.message || "Không tải được yêu cầu hỗ trợ"))
    }
}


function* updatePhanHoiWorker(action: IAppYeuCauHoTroUpdatePhanHoiStart): any {
    const res: IBaseResponeModel = yield call([appYeuCauHoTroApi, appYeuCauHoTroApi.updateKetQuaAsync], action.payload)
    if (res.is_success) {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.updatePhanHoiSuccess())
    } else {
        yield put(actions.appPhuHuynhWrapper.appYeuCauHoTro.updatePhanHoiError(res.message || "Không cập nhật được kết quả hỗ trợ"))
    }
}

export function* appYeuCauHoTroSaga(): any {
    yield takeLatest(eAppYeuCauHoTroActionTypeIds.LOAD_SELECT_START, loadSelectWorker)
    yield takeEvery(eAppYeuCauHoTroActionTypeIds.LOAD_DETAIL_START, loadDetailWorker)
    yield takeEvery(eAppYeuCauHoTroActionTypeIds.UPDATE_PHANHOI_START, updatePhanHoiWorker)
}